import axios from "axios";

export default function getAutoReplies() {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/auto-replies")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
